import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmationService, FilterService, MessageService } from "primeng/api";
import { SubSink } from "subsink";
import { DatePicker } from 'primeng/datepicker';
import { ISelectedFilters, IFiltersCriteria } from "../../lib/types/selectedFilters";
import { StorageService, CommonService } from "../../service";
import { FilterTerminatedService } from "../../service/FilterService/filter-service-terminated.service";
import { HomeService } from '../../../modules/user/home/service/home/home.service';
import { ActivatedRoute,Router } from '@angular/router';
import { SharedFilterService } from '../../service/filter-service/shared-filter.service';
import { ToastService, ToastType } from '../../service/toast/toast.service';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Component({
  selector: 'app-filter-panel-terminated',
  templateUrl: './filter-panel-terminated.component.html',
  styleUrls: ['./filter-panel-terminated.component.scss'],
  providers: [MessageService, ConfirmationService],
  standalone: false,
})
export class FilterPanelTerminatedComponent implements AfterViewInit {

  public listViewFiltersVisible: boolean = true;
  @ViewChild('loadedVesselDate') loadedVesselDate!: DatePicker;
  @ViewChild('receiptAtTerminalEventDate') receiptAtTerminalEventDate!: DatePicker;
  @ViewChild('uploadedFromVesselDate') uploadedFromVesselDate!: DatePicker;
  @ViewChild('gateOutPortEventDate') gateOutPortEventDate!: DatePicker;
  @ViewChild('emptyReturnEventDate') emptyReturnEventDate!: DatePicker;
  @ViewChild('emptyPickupPortEventDate') emptyPickupPortEventDate!: DatePicker;
  currentFilterField: string = '';
  showFilterActive: boolean = false;
  @Input() isOpen: boolean = false;
  @Output() onFilterSubmit = new EventEmitter();
  showPanel: boolean = false;
  private subscription = new SubSink();
  public isSaveFilter: boolean = true;
  public pageURL: string = '';
  public previousPageURL: string = '';
  public isEditFilter: boolean = false;
  public contractFiltersVisible: boolean = false;
  public showEditFilter: boolean = false;
  public isFilterApplied: boolean = false;
  public newFilterName: string = "";
  public isSavefilterDisabled: boolean = true;
  public isFilteredInitialized: boolean = false;
  public savedFilters: any[] = [];
  minDemurrageDays: number = -90;
  maxDemurrageDays: number = 90;
  minDetentionDays: number = -90;
  maxDetentionDays: number = 90;
  minDndDays: number = -90;
  maxDndDays: number = 90;
  billOfLadingNumber: string = '';
  bookingNumber: string = '';
  totalDemurrageFreeDays: number[] = [-90, 90];
  totalDetentionFreeDays: number[] = [-90, 90];
  totalDndFreeDays: number[] = [-90, 90];
  freeDaysSliderRange: number[] = [-90, 90];
  public filterForEdit: any = { name: "" };
  public maxSelectionLimit: number = 5;
  public portList: any[] = [];
  portData: any[] = [];
  portListData: any[] = [];
  public containerTypeList: any[] = [];
  // Location related properties
  public originRegion: any[] = [];
  public originCountry: any[] = [];
  public destinationRegion: any[] = [];
  public destinationCountry: any[] = [];
  public isUnmappedListView: boolean = false;
    public isListView: boolean = false;
selectedPortType: string = 'origin';
  private filtersFetched: boolean = false;
  public filterList: any = {
    hazNonHaz: [
      { label: 'Hazardous', value: 'haz' },
      { label: 'Non-Hazardous', value: 'nonHaz' },],
    portType: [{ label: 'Origin', value: 'origin' },
    { label: 'Destination', value: 'destination' },],
    totalDetentionFreeDays: [],
    originRegion: [],
    savedFilter: [],
    destinationRegion: [],
    originCountry: [],
    destinationCountry: [],
    totalDndFreeDays: [],
    carrierScac: [],
    billOfLadingNumber: [],
    bookingNumber: [],
    containerType: [],
    remptypickupname: [],
    receiptatterminal: [],
    loadedonvesselname: [],
    unloadedvesselname: [],
    getoutportname: [],
    emptyreturnname: [],
    currentstateofcontainer: [],
    detentionStatus: [
  { label: 'Past Free Days', value: 'past' },
  { label: 'Last Free Days', value: 'last' },
  { label: 'Near Free Days', value: 'near' },
  { label: 'Safe Free Days', value: 'safe' }
],
   demurrageStatus: [
  { label: 'Past Free Days', value: 'past' },
  { label: 'Last Free Days', value: 'last' },
  { label: 'Near Free Days', value: 'near' },
  { label: 'Safe Free Days', value: 'safe' }
   ],
   dndStatus: [
  { label: 'Past Free Days', value: 'past' },
  { label: 'Last Free Days', value: 'last' },
  { label: 'Near Free Days', value: 'near' },
  { label: 'Safe Free Days', value: 'safe' }
   ]
  };
  public contactFilter: any = {
    demurageFreeDays: [],
    totalDemurrageFreeDays: [],
    totalDndFreeDays: [],
    originRegion: [],
    destinationRegion: [],
    originCountry: [],
    destinationCountry: [],
    portOfDeparture: [],
    portOfArrival: [],
    portUnloc: [],
    carrierScac: [],
    carrierName: [],
    portType: null,
    containerType: [],
    hazMat: [],
  }

  // Autocomplete filters
  public selectedAutoCompleteFilters: any = {

  };

  public suggestedFilterList: any = {
    bdpReferenceNumber: [],
    containerNumber: [],
    totalDemurrageFreeDays: [],
    totalDetentionFreeDays: [],
    totalDndFreeDays: [],
    portOfDeparture: [],
    portOfArrival: [],
    hazMat: [],
    bdpRepresentativeName: [],
    detentionStatus: [
  { label: 'Past Free Days', value: 'past' },
  { label: 'Last Free Days', value: 'last' },
  { label: 'Near Free Days', value: 'near' },
  { label: 'Safe Free Days', value: 'safe' }
],
demurrageStatus: [
  { label: 'Past Free Days', value: 'past' },
  { label: 'Last Free Days', value: 'last' },
  { label: 'Near Free Days', value: 'near' },
  { label: 'Safe Free Days', value: 'safe' }
],
dndStatus: [
  { label: 'Past Free Days', value: 'past' },
  { label: 'Last Free Days', value: 'last' },
  { label: 'Near Free Days', value: 'near' },
  { label: 'Safe Free Days', value: 'safe' }
],

  };

  public selectedInput: any = {
    bdpReferenceNumber: '',
    containerNumber: '',
    bdpRepresentativeName: '',
    billOfLadingNumber: '',
    bookingNumber: '',
    demurrageTotalCost: '',
    detentionTotalCost: '',
    dndTotalCost: '',
  };

  selectedDateFilters: any = {
    emptyReturnEventDate: [],
    emptyPickupPortEventDate: [],
    placeOfRecipientPortEventDate: [],
    receiptAtTerminalEventDate: [],
    uploadedFromVesselDate: [],
    loadedVesselDate: [],
    gateOutPortEventDate: [],
  }


  // Selected filters
  public selectedFilters: any = {
    bdpReferenceNumber: [],
    containerNumber: [],
    carrierScac: [],
    billOfLadingNumber: [],
    bookingNumber: [],
    emptyPickupPortUnloc: [],
    receiptAtTerminalUnloc: [],
    loadedOnVesselUnloc: [],
    unloadedFromVesselUnloc: [],
    gateOutPortUnloc: [],
    emptyReturnUnloc: [],
    emptyReturnEventDate: [],
    emptyPickupPortEventDate: [],
    loadedVesselDate: [],
    receiptAtTerminalEventDate: [],
    uploadedFromVesselDate: [],
    gateOutPortEventDate: [],
    currentStateOfContainer: [],
    originRegionFilter: [],
    originCountry: [],
    portOfDeparture: [],
    destinationRegionFilter: [],
    destinationCountry: [],
    portOfArrival: [],
    portUnloc: [],
    portType: null,
    containerType: [],
    hazMat: [],
    bdpRepresentativeName: [],
    detentionStatus: "",
demurrageStatus: "",
dndStatus: ""

  };
  private filterSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  filterRequest$: Observable<any> = this.filterSubject.asObservable();
  // Visible filters array
  public visibleFilters: string[] = [
    'bdpReferenceNumber',
    'containerNumber',
    'totalDemurrageFreeDays',
    'totalDetentionFreeDays',
    'totalDndFreeDays',
    'detentionStatus',
    'demurrageStatus',
    'dndStatus',
    'originRegion',
    'originCountry',
    'portOfDeparture',
    'destinationRegion',
    'destinationCountry',
    'portOfArrival',
    'portUnloc',
    'portType',
    'carrierScac',
    'billOfLadingNumber',
    'bookingNumber',
    'containerType',
    'hazNonHaz',
    'bdpRepresentativeName',
    'remptypickupname',
    'receiptatterminal',
    'loadedonvesselname',
    'unloadedvesselname',
    'getoutportname',
    'emptyreturnname',
    'emptypickupporteventdate',
    'loadfromvesseldate',
    'receiptatterminaleventdate',
    'uploadedfromvesseldate',
    'gateOutPortEventDate',
    'emptyretureventdate',
    'currentstateofcontainer',
  ];
  undoFilter: any;
  globalRegion: any;
  globalCountry: any;
  selectedCompanies: string[];
  bdpRepresentativeList: any;
  datepickerMap: any = {
    emptyPickupPortEventDate: [],
    loadedVesselDate: [],
    receiptAtTerminalEventDate: [],
    uploadedFromVesselDate: [],
    gateOutPortEventDate: [],
    emptyReturnEventDate: [],
  };
 private hasFetchedFilters: boolean = false;

  constructor(
    private filterService: FilterTerminatedService,
    private storageService: StorageService,
    private commonService: CommonService,
    private messageService: MessageService,
    private homeService: HomeService,
    private changeDetectorRef: ChangeDetectorRef,
    private sharedFilterService: SharedFilterService,
    private toastService: ToastService,
    private router: Router,

  ) {
    this.subscription.add(
      this.filterService.getPortList().subscribe(res => {
        if (res.data) {
          this.portListData = res.data;
          this.filterList.originRegion = res.data.map((data: any) => ({
            value: data.regionName,
            label: data.regionName
          }));
          this.filterList.destinationRegion = res.data.map((data: any) => ({
            value: data.regionName,
            label: data.regionName
          }));
          this.filterList.originCountry = res.data.flatMap((data: any) =>
            data.countries.map((country: any) => ({
              value: country.countryCode,
              label: country.countryName
            }))
          );

          this.filterList.destinationCountry = this.filterList.originCountry;
        }
      }
      ),
      this.filterService.getBdpRepresentative().subscribe(res => {
        if (res.data) {
          this.bdpRepresentativeList = res.data.map((port: any) => ({
            label: port.bdpRepresentativeName,
            value: port.bdpRepresentativeName
          }));

        }
      }),
      this.filterService.getPorts().subscribe(res => {
        if (res.data) {
          this.portData = res.data;
          this.portList = res.data.map((port: any) => ({
            label: `${port.portName} (${port.portUnloc})`,
            value: port.portUnloc
          }));
          console.log(this.suggestedFilterList.portOfDeparture);
        }
      }
      ),
      this.filterService.getContainerType().subscribe(res => {
        if (res.data) {
          this.filterList.containerType = res.data;
        }
      }),
      this.filterService.getCarrier().subscribe((res: any) => {
        if (res.data) {
          this.filterList.carrierScac = res.data.map((carrier: any) => ({
            value: `${carrier.carrierName} (${carrier.carrierScac})`, id: carrier.carrierScac
          }));
        }
      }
      ),
      this.homeService.$origionRegion.subscribe((region: any) => {
        this.originRegion = region;
      }),
      this.homeService.$destinationRegion.subscribe((region: any) => {
        this.destinationRegion = region;
      }),
    )
    this.filterService.updateListViewFilter(this.selectedFilters);
  }
  ngAfterViewInit(): void {
    this.datepickerMap = {
      emptyPickupPortEventDate: this.emptyPickupPortEventDate,
      loadedVesselDate: this.loadedVesselDate,
      receiptAtTerminalEventDate: this.receiptAtTerminalEventDate,
      uploadedFromVesselDate: this.uploadedFromVesselDate,
      gateOutPortEventDate: this.gateOutPortEventDate,
      emptyReturnEventDate: this.emptyReturnEventDate
    };
  }

ngOnInit() {
   if (this.filtersFetched) {
    return; 
  }
  this.subscription.add(
    this.filterService.filterVisibility$.subscribe(visibility => {
      this.showPanel = visibility.filterVisibility;
      this.isOpen = visibility.filterVisibility;
      this.pageURL = visibility.url || '';
      console.log("pageUrL",this.pageURL )
      this.listViewFiltersVisible = this.pageURL.includes('list-view');
      this.contractFiltersVisible = this.pageURL.includes('contract');
      this.isUnmappedListView = this.pageURL.includes('unmapped');
      console.log("isUnmappedListView",this.isUnmappedListView);
      this.isListView = this.pageURL.includes('list-view');
      if (this.isUnmappedListView) {
        this.selectedFilters.detentionStatus = '';
        this.selectedFilters.demurrageStatus = '';
        this.selectedFilters.dndStatus = '';
      }
      if (this.pageURL && this.pageURL !== this.previousPageURL) {
        this.previousPageURL = this.pageURL;
        this.setRangeValues();
      }
     
    }),
    );
   this.subscription.add(
  this.sharedFilterService.dashboardFilter$.subscribe(filter => {
    this.selectedPortType = filter.portType;   // origin | destination | both
  })
);
  if (this.router.url.includes('list-view') && !this.router.url.includes('unmapped')) {
    this.filterService.getSavedFilters().subscribe((res: any) => {
      if (res) {
        this.savedFilters = res;
        this.filtersFetched = true;
      }
    });
  } else if (this.router.url.includes('unmapped')) {
    this.filterService.getSavedUnmappedFilters().subscribe((res: any) => {
      if (res) {
        this.savedFilters = res;
        this.filtersFetched = true; 
      }
    });
  }
}



  private setRangeValues(): void {
    //if(this.isEditFilter) return;
    if (this.listViewFiltersVisible) {
      // Set ranges for list-view
      this.totalDemurrageFreeDays = [-90, 90];
      this.totalDetentionFreeDays = [-90, 90];
      this.totalDndFreeDays = [-90, 90];
      this.minDemurrageDays = -90;
      this.maxDemurrageDays = 90;
      this.minDetentionDays = -90;
      this.maxDetentionDays = 90;
      this.minDndDays = -90;
      this.maxDndDays = 90;
      this.freeDaysSliderRange = [-90, 90];
    } else if (this.contractFiltersVisible) {
      // Set ranges for contract
      this.totalDemurrageFreeDays = [0, 50];
      this.totalDetentionFreeDays = [0, 50];
      this.totalDndFreeDays = [0, 50];
      this.minDemurrageDays = 0;
      this.maxDemurrageDays = 50;
      this.minDetentionDays = 0;
      this.maxDetentionDays = 50;
      this.minDndDays = 0;
      this.maxDndDays = 50;
      this.freeDaysSliderRange = [0, 50];
    }
  }

  selectFilter(filter: any) {
    if (filter.selected) return;
    this.savedFilters.map((tFilter: any) => {
      tFilter.selected = false;
    });
    filter.selected = true;
    this.selectedFilters = JSON.parse(filter.savedFilterJson);
    for (let key of Object.keys(this.selectedFilters)) {
      if (this.selectedInput.hasOwnProperty(key)) {
        if (key === 'bdpRepresentativeName') {
          this.selectedInput[key] = this.selectedFilters[key].map((value: any) => value.label).join(',');
        } else {
          this.selectedInput[key] = this.selectedFilters[key].join(',');
          this.selectedFilters = Object.fromEntries(
            Object.entries(this.selectedFilters).filter(([k]) => k !== key))

        }
      }
      if (key == 'minDemurrageDays' || key == 'maxDemurrageDays') {
        this.totalDemurrageFreeDays = [this.selectedFilters.minDemurrageDays, this.selectedFilters.maxDemurrageDays]
        this.minDemurrageDays = this.selectedFilters.minDemurrageDays;
        this.maxDemurrageDays = this.selectedFilters.maxDemurrageDays;
      }
      if (key == 'minDetentionDays' || key == 'maxDetentionDays') {
        this.totalDetentionFreeDays = [this.selectedFilters.minDetentionDays, this.selectedFilters.maxDetentionDays]
        this.minDetentionDays = this.selectedFilters.minDetentionDays;
        this.maxDetentionDays = this.selectedFilters.maxDetentionDays;
      }
      if (key == 'minDndDays' || key == 'maxDndDays') {
        this.totalDndFreeDays = [this.selectedFilters.minDndDays, this.selectedFilters.maxDndDays]
        this.minDndDays = this.selectedFilters.minDndDays;
        this.maxDndDays = this.selectedFilters.maxDndDays;
      }

      if (this.selectedDateFilters.hasOwnProperty(key)) {
        this.selectedDateFilters[key] = this.selectedFilters[key];
        if (Array.isArray(this.selectedDateFilters[key]) && this.selectedDateFilters[key].length === 2) {
          const formattedRange = this.selectedDateFilters[key].map((date: any) => {
            const isoDate = new Date(date);
            return isoDate;
          });
          this.selectedDateFilters[key] = formattedRange;

        }
      }
    }
    console.log(this.selectedDateFilters);

  }

  onDateChange(event: any, key: string) {
    console.log(this.selectedDateFilters[key])
    if (event && Array.isArray(this.selectedDateFilters[key]) && this.selectedDateFilters[key].length === 2) {
      const formattedRange = this.selectedDateFilters[key].map((date: any) => {
        return this.commonService.formatDateForAPI(date);
      });
      this.selectedFilters[key] = formattedRange;

    }
  }
  removeSavedFilter(filter: any) {

    this.filterService
      .setSavedFilters({
        filterJsonText: "",
        filterName: filter.savedFilterName,
        savedFilterId: filter.id,
        isDeleted: true
      })
      .subscribe((res) => {
        if (res) {
          const index = this.savedFilters.indexOf(filter);
          if (index > -1) {
            this.undoFilter = JSON.parse(JSON.stringify(filter));
            this.savedFilters.splice(index, 1);
            this.messageService.add({
              key: "bcu",
              severity: "success",
              summary: 'Success',
              detail:
                "Filter “" +
                filter.savedFilterName +
                "”  has been successfully deleted.",
              data: "filterRemoved",
              life: 5000,
            });
          } else {
            this.undoFilter = undefined;
          }
        }
      });
  }

  // Filter panel visibility methods
  onFilterClick() {
    this.showPanel = true;
    this.isFilteredInitialized = true;
  }

  onHazMatChange(value: string) {
    this.selectedFilters.hazMat = [value];
  }


  closeSidebar() {
    this.filterService.changeFilterVisibility(false);
    this.isEditFilter = false;
    this.showPanel = false;
    this.showEditFilter = false;
    this.isSaveFilter = true;
  }

  // Filter operations
  onFilterApplied() {
    let apiCalled = false;
    this.processSelectedInput();
    this.sharedFilterService.selectedCompanies$.subscribe(
      (selectedCompanies: string[]) => {
        this.selectedCompanies = selectedCompanies;
      }),
      this.filterService.filterVisibility$.subscribe(
        visibility => {
          this.showPanel = visibility.filterVisibility;
          this.isOpen = visibility.filterVisibility;
          this.pageURL = visibility.pageURL;
          if (visibility.regionFilter !== undefined) {
            this.globalRegion = visibility.regionFilter;
          }
          if (visibility.countryFilter !== undefined) {
            this.globalCountry = visibility.countryFilter;
          }
        }
      )

    let paginationData: any = [];
    this.filterService.$paginationState.subscribe((paginationState: any) => {
      paginationData = paginationState;
    }

    );
    this.showFilterActive = this.hasActiveFilters();
    this.filterService.updateShowFilter(this.showFilterActive);
    // const portOfDeparture = this.selectedFilters.portOfDeparture.map((port: any) => port.value);;
    // const portOfArrival =this.selectedFilters.portOfArrival.map((port: any) => port.value);;
    // this.selectedFilters.portOfDeparture = portOfDeparture;
    // this.selectedFilters.portOfArrival = portOfArrival;
    if (this.isUnmappedListView) {
      this.selectedFilters.detentionStatus = '';
      this.selectedFilters.demurrageStatus = '';
      this.selectedFilters.dndStatus = '';
    }
    const requestBody = {
      ...this.selectedFilters,
      minDemurrageDays: this.minDemurrageDays,
      maxDemurrageDays: this.maxDemurrageDays,
      minDetentionDays: this.minDetentionDays,
      maxDetentionDays: this.maxDetentionDays,
      minDndDays: this.minDndDays,
      maxDndDays: this.maxDndDays,
      region: this.globalRegion,
      country: this.globalCountry,
      company: this.selectedCompanies,


    };
    if (!this.isFilteredInitialized) {
      this.sharedFilterService.updateFilterRequestListView(requestBody);
      apiCalled = true;
    }
    if (!apiCalled) {
      this.onFilterSubmit.emit(requestBody);
    }
    if (this.router.url.includes('contract-agreement')) {
      this.onFilterSubmit.emit(requestBody);
    }

    this.closeOverlay();
    this.showPanel = false;
    for (const key of Object.keys(this.selectedInput)) {
      this.selectedFilters[key] = [];
    }
  }

  processSelectedInput() {
    for (const key of Object.keys(this.selectedInput)) {
      if (!this.selectedFilters[key]) {
        this.selectedFilters[key] = [];
      }
      if (this.selectedInput[key].length > 0) {
        const newValues = this.selectedInput[key]
          .split(',')
          .filter((value: any) => !this.selectedFilters[key].includes(value));

        this.selectedFilters[key].push(...newValues);
      }
    }
  }



  hasActiveFilters(): boolean {
    const slidersChanged =
      (this.minDemurrageDays !== null && this.minDemurrageDays !== this.freeDaysSliderRange[0]) ||
      (this.maxDemurrageDays !== null && this.maxDemurrageDays !== this.freeDaysSliderRange[1]) ||
      (this.minDetentionDays !== null && this.minDetentionDays !== this.freeDaysSliderRange[0]) ||
      (this.maxDetentionDays !== null && this.maxDetentionDays !== this.freeDaysSliderRange[1]) ||
      (this.minDndDays !== null && this.minDndDays !== this.freeDaysSliderRange[0]) ||
      (this.maxDndDays !== null && this.maxDndDays !== this.freeDaysSliderRange[1]);

    const otherFiltersActive = Object.values(this.selectedFilters).some(value =>
      Array.isArray(value) ? value.length > 0 : !!value
    );

    return slidersChanged || otherFiltersActive;
  }
  closeOverlay() {
    const elem = document.getElementsByClassName("p-overlay-mask")[0];
    if (elem) {
      var evObj = document.createEvent("Events");
      evObj.initEvent("click", false, false);
      elem.dispatchEvent(evObj);
    }
  }


  isFilterDuplicate(newFilter: any, savedFilters: any[], newFlterName: any): boolean {
    const newFilterJson = JSON.stringify(newFilter);
    return savedFilters.some(savedFilter => {
      return savedFilter.savedFilterName === newFlterName || JSON.stringify(JSON.parse(savedFilter.savedFilterJson)) === newFilterJson;
    });
  }


  checkMaxSelection(key: string) {
    if (this.selectedFilters[key].length > 5) {
      this.messageService.add({
        key: "emptyToster",
        severity: "error",
        life: 5000,
        summary: "Error",
        detail: "you can select max 5 ",
      });
      return;
    }
  }

  clearFilter() {
    console.log("clear filter");
    this.selectedFilters = {};
    this.selectedFilters.hazMat = [];
    this.selectedDateFilters = [];
    this.filterList.originCountry = this.portListData.flatMap((data: any) =>
      data.countries.map((country: any) => ({
        value: country.countryCode,
        label: country.countryName
      }))
    );

    this.filterList.destinationCountry = this.filterList.originCountry;
    this.selectedAutoCompleteFilters = {};
    this.selectedInput = {};
    this.showFilterActive = false;
    this.filterService.updateShowFilter(this.showFilterActive);
    this.setRangeValues();
    this.onFilterApplied();
    // this.filterService.clearFilters();
  }



  updateMinMax(Event: any, type: any) {
    switch (type) {
      case 'detention':
        this.minDetentionDays = Event.values[0];
        this.maxDetentionDays = Event.values[1];
        break;
      case 'demurrage':
        this.minDemurrageDays = Event.values[0];
        this.maxDemurrageDays = Event.values[1];
        break;
      case 'demurrage&detention':
        this.minDndDays = Event.values[0];
        this.maxDndDays = Event.values[1];
        break;

    }
  }



  onMinMaxChange() {
    if (this.minDemurrageDays > this.maxDemurrageDays) {
      [this.minDemurrageDays, this.maxDemurrageDays] = [this.maxDemurrageDays, this.minDemurrageDays];
    }
    this.selectedFilters.totalDemurrageFreeDays = [this.minDemurrageDays, this.maxDemurrageDays];
  }

  // Autocomplete methods
  filterSuggestedList(event: any, filterName: string) {
    const query = event.query.toLowerCase();
    const filterList = this.portList;
    this.suggestedFilterList[filterName] = filterList.filter((item: any) =>
      item.label.toLowerCase().includes(query)
    );
  }

  filterRepresentativeSuggestedList(event: any, filterName: string) {
    const query = event.query.toLowerCase();
    const filterList = this.bdpRepresentativeList;
    this.suggestedFilterList[filterName] = filterList.filter((item: any) =>
      item.label.toLowerCase().includes(query)
    );
  }
  
  setAutoCompleteFilter(filterName: string) {
    switch (filterName) {
      case 'portOfDeparture':
        this.selectedFilters.originCountry = this.portData
          .filter((port: any) =>
            this.selectedFilters.portOfDeparture.some(
              (selected: any) => selected === port.portUnloc
            )
          )
          .map((port: any) => port.countryCode);
        this.selectedFilters.originRegion = this.portData
          .filter((port: any) =>
            this.selectedFilters.portOfDeparture.some(
              (selected: any) => selected === port.portUnloc
            )
          )
          .map((port: any) => port.region);
        break;
      case 'portOfArrival':
        this.selectedFilters.destinationCountry = this.portData
          .filter((port: any) =>
            this.selectedFilters.portOfArrival.some(
              (selected: any) => selected === port.portUnloc
            )
          )
          .map((port: any) => port.countryCode);
        this.selectedFilters.destinationRegion = this.portData
          .filter((port: any) =>
            this.selectedFilters.portOfArrival.some(
              (selected: any) => selected === port.portUnloc
            )
          )
          .map((port: any) => port.region);
        break;
    }
  }
  saveEnabled() {
    this.isSavefilterDisabled = this.newFilterName.length ? false : true || !this.hasActiveFilters();
  }
  saveFilter() {
    this.processSelectedInput();
    const requestBody = {
      ...Object.fromEntries(
        Object.entries(this.selectedFilters)
          .filter(([_, value]) =>
            (Array.isArray(value) && value.length > 0) ||
            (value !== null && value !== undefined)
          )
      ),
      minDemurrageDays: this.minDemurrageDays,
      maxDemurrageDays: this.maxDemurrageDays,
      minDetentionDays: this.minDetentionDays,
      maxDetentionDays: this.maxDetentionDays,
      minDndDays: this.minDndDays,
      maxDndDays: this.maxDndDays,

    };

    if (this.isFilterDuplicate(requestBody, this.savedFilters, "")) {
      this.toastService.showToast(ToastType.ERROR, ' filter selection already exist!.', 5000);
      return;
    }
    this.filterService
      .setSavedFilters({
        filterJsonText: JSON.stringify(requestBody),
        filterName: this.filterForEdit.savedFilterName,
        savedFilterId: this.filterForEdit.id,
        isDeleted: false
      })
      .subscribe((res) => {
        if (res) {
          this.savedFilters.map((filter) => {
            if (filter.id == this.filterForEdit.id) {
              (filter.value = JSON.stringify(
                this.selectedFilters
              )),
                (filter.selected = true);
            } else {
              filter.selected = false;
            }
          });
          this.isEditFilter = false;
          this.messageService.add({
            key: "bcu",
            sticky: true,
            severity: "success",
            summary: 'Success',
            detail:
              "Filter " +
              "“" +
              this.filterForEdit.savedFilterName +
              "” saved successfully.",
            data: "filterModified",
            life: 5000,
          });
          this.filterService.getSavedFilters().subscribe((res: any) => {
            if (res) {
              this.savedFilters = res;
            }
          })
        }
      });
  }

  editFilter(filter: any) {
    this.isEditFilter = true;
    this.showEditFilter = false;
    this.filterForEdit = filter;
    this.selectedFilters = JSON.parse(filter.savedFilterJson);
    this.undoFilter = JSON.parse(JSON.stringify(filter));
  }
  createFilter() {
    if (this.newFilterName.length == 0) {
      this.messageService.add({
        key: "emptyToster",
        severity: "error",
        life: 5000,
        summary: "Error",
        detail: "Please provide the filter name to save the filter!",
      });
      return;
    }




    if (this.savedFilters.length === 5) {
      this.toastService.showToast(ToastType.ERROR, 'you can save max 5 filter!.', 5000);
    }


    this.processSelectedInput();

    const requestBody = {
      ...Object.fromEntries(
        Object.entries(this.selectedFilters)
          .filter(([_, value]) =>
            (Array.isArray(value) && value.length > 0) ||
            (value !== null && value !== undefined)
          )
      ),
      minDemurrageDays: this.minDemurrageDays,
      maxDemurrageDays: this.maxDemurrageDays,
      minDetentionDays: this.minDetentionDays,
      maxDetentionDays: this.maxDetentionDays,
      minDndDays: this.minDndDays,
      maxDndDays: this.maxDndDays,

    };
    if (this.isFilterDuplicate(requestBody, this.savedFilters, this.newFilterName)) {
      this.toastService.showToast(ToastType.ERROR, 'filter name or filter selection already exist!.', 5000);
      return;
    }

    this.filterService
      .setSavedFilters({
        filterJsonText: JSON.stringify(requestBody),
        filterName: this.newFilterName,
        savedFilterId: 0,
        isDeleted: false
      })
      .subscribe((res: any) => {
        if (res) {
          const filter = {
            name: this.newFilterName,
            savedFilterName: this.newFilterName,
            savedFilterJson: JSON.stringify(requestBody),
            value: JSON.stringify(requestBody),
            id: res.id,
            selected: false,
          };
          this.savedFilters.unshift(filter);
          // this.undoFilter = JSON.parse(JSON.stringify(filter));
          this.isSaveFilter = true;
          this.messageService.add({
            key: "bcu",
            severity: "success",
            summary: 'Success',
            detail:
              "Filter " +
              "“" +
              this.newFilterName +
              "” saved successfully.",
            data: "filterCreated",
            life: 5000,
          });
          this.isSaveFilter = true;
          this.showEditFilter = true;
        }
      });


  }

  onCalenderPanelHide(datepicker: any, field: string) {
    const range = this.selectedDateFilters[field].filter((date: any) => date !== null && date !== undefined);
    const isRangeIncomplete = range && range.length != 0 && range.length < 2;
    if (isRangeIncomplete) {
      this.toastService.showToast(ToastType.ERROR, 'Please select a complete date range.', 5000);
      setTimeout(() => {
        const datepickerComponent = this.datepickerMap[field]?.inputfieldViewChild?.nativeElement;
        if (datepickerComponent) {
          datepickerComponent.focus();
        }
      }, 150);
      return;
    }
  }


  // Location change handlers
  onLocationChange(filterField: number, event: any, selectedFilters: any) {
    switch (filterField) {
      case 1: // originRegion
        this.filterCountryAndPorts('origin', event.value);
        break;
      case 2: // originCountry
        this.getPODPOAList('POD');
        break;
      case 4: // destinationRegion
        this.filterCountryAndPorts('destination', event.value);
        break;
      case 5: // destinationCountry
        this.getPODPOAList('POA');
        break;
    }
  }

  private filterCountryAndPorts(type: 'origin' | 'destination', selectedRegions: string[]) {
    if (!selectedRegions?.length) {
      if (type === 'origin') {
        this.filterList.originCountry = this.portListData.flatMap((data: any) =>
          data.countries.map((country: any) => ({
            value: country.countryCode,
            label: country.countryName
          }))
        );
      }
      if (type === 'destination') {
        this.filterList.destinationCountry = this.portListData.flatMap((data: any) =>
          data.countries.map((country: any) => ({
            value: country.countryCode,
            label: country.countryName
          }))
        );
      }
      return;
    }

    if (type === 'origin') {
      this.filterList.originCountry = this.portListData
        .filter((port: any) => selectedRegions.includes(port.regionName))
        .flatMap((data: any) =>
          data.countries.map((country: any) => ({
            value: country.countryCode,
            label: country.countryName
          }))
        );
    }
    if (type === 'destination') {
      this.filterList.destinationCountry = this.portListData
        .filter((port: any) => selectedRegions.includes(port.regionName))
        .flatMap((data: any) =>
          data.countries.map((country: any) => ({
            value: country.countryCode,
            label: country.countryName
          }))
        );
    }
  }


  onInputChange(event: any, filterName: string) {
    this.selectedFilters[filterName].push(event.value);
  }

  getPODPOAList(type: 'POD' | 'POA') {
    const filters = this.filterService.getIds(this.selectedFilters);
    const serviceCall = type === 'POD' ?
      this.commonService.getPOD(filters) :
      this.commonService.getPOA(filters);

    serviceCall.subscribe(ports => {
      if (ports) {
        const formattedPorts = ports.map((port: { value: any; id: any; }) => ({
          ...port,
          value: `${port.value} (${port.id})`
        }));

        if (type === 'POD') {
          this.filterList.portOfDeparture = formattedPorts;
        } else {
          this.filterList.portOfArrival = formattedPorts;
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getFilters(): Observable<any> {
  // Determine where the request is coming from (you can use route parameters, URL, or any other method)
  const currentPage = this.router.url;

  if (currentPage.includes('list-view')) {
    // Call getSavedFilters API
    return this.filterService.getSavedFilters();  // Replace with actual API call
  } else if (currentPage.includes('unmapped')) {
    // Call getSavedUnmappedFilters API
    return this.filterService.getSavedUnmappedFilters();  // Replace with actual API call
  } else {
    // Default or error handling if needed
    return of([]);
  }
}
}

